import { NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './/app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { PageNotFoundComponent } from './auth/page-not-found/page-not-found.component';
import { MODULES } from './global-modules';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ClickableClickModule } from 'angular-clickable-click';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ChangePasswordChallengeComponent } from './auth/change-password-challenge/change-password-challenge.component';
import { FooterModule } from './pages/footer/footer.module';
import { ConfirmComponent } from './utils/confirm/confirm.component';
import { EmailInputComponent } from './utils/email-input/email-input.component';
import { LandingPageComponent } from './auth/landing-page/landing-page.component';
import { ConsolidatorSelectionComponent } from './services/dialog/consolidator-selection/consolidator-selection.component';
import { DirectivesModule } from './directives/directives.module';
import { PrivacyPolicyComponent } from './auth/privacy-policy/privacy-policy.component';
import { SharedComponentsModule } from './_shared-components/shared-components.module';
import { environment } from 'src/environments/environment';
import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: environment.auth,
  API: environment.api
})

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        PageNotFoundComponent,
        ChangePasswordChallengeComponent,
        ConfirmComponent,
        EmailInputComponent,
        LandingPageComponent,
        ConsolidatorSelectionComponent,
        PrivacyPolicyComponent
    ],
    imports: [
        BrowserModule,
        FooterModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ClickableClickModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            useDefaultLang: true,
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
      ...MODULES,
      DirectivesModule,
      SharedComponentsModule
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule {
  constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer){
    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg'));
  }
}
